import React, { useEffect, useState } from 'react'
import emailjs from '@emailjs/browser';
import styled from 'styled-components'
import { motion } from 'framer-motion'
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import FavoriteIcon from '@mui/icons-material/Favorite';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
const ContactUs = () => {
    const [submit, setSubmit] = useState(false)
    const [data, setData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });


    const handleSubmission = (e) => {
        e.preventDefault();
        if (data.name && data.email && data.subject && data.message) {
            emailjs.send('service_po6idda', 'template_g5erg0q', data, 'Ob6YgTaYqeObolMjc')
                .then((response) => {
                    setSubmit(true)
                }).catch((error) => {
                    setSubmit(false)
                    setData({
                        ...data,
                        name: '',
                        email: '',
                        subject: '',
                        message: ''
                    })
                });
        }
    };

    useEffect(() => {
        let id = setInterval(() => {
            setSubmit(false);

        }, 5000)

        if (!submit) {
            setData({
                ...data,
                name: '',
                email: '',
                subject: '',
                message: ''
            })
        };

        return () => {
            clearInterval(id)
        }

    }, [submit]);

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                duration: 0.6,
                staggerChildren: 0.2
            }
        },
        exit: {
            opacity: 0,
            transition: {
                duration: 0.4,
                staggerChildren: 0.1,
                staggerDirection: -1
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 50 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.6,
                ease: "easeOut"
            }
        },
        exit: {
            opacity: 0,
            y: -50,
            transition: {
                duration: 0.4,
                ease: "easeIn"
            }
        }
    };

    const contactCardVariants = {
        hover: {
            y: -5,
            scale: 1.02,
            transition: {
                duration: 0.3,
                ease: "easeInOut"
            }
        }
    };

    const buttonVariants = {
        hover: {
            y: -2,
            scale: 1.05,
            backgroundColor: "#019a6b",
            transition: {
                duration: 0.2,
                ease: "easeInOut"
            }
        },
        tap: {
            scale: 0.95
        }
    };

    const inputVariants = {
        focus: {
            scale: 1.02,
            borderColor: "#01a479",
            transition: {
                duration: 0.2
            }
        }
    };

    return (
        <Container id='contact'>
            <motion.div 
                className='contact'
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                exit="exit"
                viewport={{ once: false, margin: "-100px" }}
            >
                <motion.div className='contactText' variants={itemVariants}>
                    <motion.div
                        initial={{ opacity: 0, y: -30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6 }}
                    >
                        <h1>Contact Me</h1>
                    </motion.div>
                    <motion.div 
                        className='middleSection'
                        variants={containerVariants}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                    >
                        <motion.div
                            variants={itemVariants}
                            whileHover={contactCardVariants.hover}
                        >
                            <motion.div
                                whileHover={{ rotate: [0, -10, 10, 0] }}
                                transition={{ duration: 0.5 }}
                            >
                                <LinkedInIcon fontSize="large" />
                            </motion.div>
                            <h1>LinkedIn</h1>
                            <p>You can contact me on LinkedIn</p>
                            <a href="https://www.linkedin.com/in/mohit-sharma-66176314a/" rel="noreferrer" target="_blank">
                                <p>mohit-sharma</p>
                            </a>
                        </motion.div>
                        <motion.div
                            variants={itemVariants}
                            whileHover={contactCardVariants.hover}
                        >
                            <motion.div
                                whileHover={{ rotate: [0, -10, 10, 0] }}
                                transition={{ duration: 0.5 }}
                            >
                                <PhoneIcon fontSize="large" />
                            </motion.div>
                            <h1>Phone</h1>
                            <p>Here is My Phone Number</p>
                            <a href="tel:+917983810058" rel="noreferrer" target="_blank">
                                <p>+917983810058</p>
                            </a>
                        </motion.div>
                        <motion.div
                            variants={itemVariants}
                            whileHover={contactCardVariants.hover}
                        >
                            <motion.div
                                whileHover={{ rotate: [0, -10, 10, 0] }}
                                transition={{ duration: 0.5 }}
                            >
                                <EmailIcon fontSize="large" />
                            </motion.div>
                            <h1>Email</h1>
                            <p>You can Simply mail me just by clicking on my email</p>
                            <a href='mailto:mohitkumarsharma@gmail.com' rel="noreferrer" target="_blank">
                                <p>mohitkumarsharma@gmail.com</p>
                            </a>
                        </motion.div>
                        <motion.div
                            variants={itemVariants}
                            whileHover={contactCardVariants.hover}
                        >
                            <motion.div
                                whileHover={{ rotate: [0, -10, 10, 0] }}
                                transition={{ duration: 0.5 }}
                            >
                                <LocationOnIcon fontSize="large" />
                            </motion.div>
                            <h1>Location</h1>
                            <p>Rishikesh,Uttarakhand</p>
                            <a href="https://www.google.com/maps/place/Veerbhadra,+Uttarakhand/@30.0479292,78.4212561,11.16z/data=!4m5!3m4!1s0x39093e1730e30441:0x7aceaa46b9f267fe!8m2!3d30.0771701!4d78.2874772" rel="noreferrer" target="_blank">
                                <p>View on Google map</p>
                            </a>
                        </motion.div>
                    </motion.div>
                </motion.div>
                {submit && 
                    <motion.div 
                        className='emailSent'
                        initial={{ opacity: 0, scale: 0.8, y: 20 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        exit={{ opacity: 0, scale: 0.8, y: -20 }}
                        transition={{ duration: 0.5, ease: "easeOut" }}
                    >
                        <motion.h1 
                            style={{ color: '#01a479' }}
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ delay: 0.2, duration: 0.5 }}
                        >
                            Email Sent Successfully.
                        </motion.h1>
                        <motion.p
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ delay: 0.4, duration: 0.5 }}
                        >
                            Thank you <span style={{ fontWeight: 'bold' }}>{data.name}</span>, your message has been submitted to us.
                        </motion.p>
                    </motion.div>
                }
                <motion.div 
                    className='contactForm'
                    variants={itemVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                >
                    <form action="" onSubmit={handleSubmission}>
                        <motion.div
                            initial={{ opacity: 0, x: -50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: 0.2 }}
                        >
                            <motion.input 
                                value={submit ? '' : data.name} 
                                type="text" 
                                name='name' 
                                placeholder='Name' 
                                onChange={(e) => setData({ ...data, name: e.target.value })}
                                variants={inputVariants}
                                whileFocus="focus"
                            />
                            <motion.input 
                                value={submit ? '' : data.email} 
                                type="email" 
                                name='email' 
                                placeholder='Email' 
                                onChange={(e) => setData({ ...data, email: e.target.value })}
                                variants={inputVariants}
                                whileFocus="focus"
                            />
                            <motion.input 
                                value={submit ? '' : data.subject} 
                                type="text" 
                                name='subject' 
                                placeholder='Subject' 
                                onChange={(e) => setData({ ...data, subject: e.target.value })}
                                variants={inputVariants}
                                whileFocus="focus"
                            />
                        </motion.div>
                        <motion.div
                            initial={{ opacity: 0, x: 50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: 0.4 }}
                        >
                            <motion.textarea 
                                value={submit ? '' : data.message} 
                                type="text" 
                                name='message' 
                                placeholder='Your Message' 
                                onChange={(e) => setData({ ...data, message: e.target.value })}
                                variants={inputVariants}
                                whileFocus="focus"
                            />
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.6, delay: 0.6 }}
                            >
                                <motion.button 
                                    type='submit'
                                    variants={buttonVariants}
                                    whileHover="hover"
                                    whileTap="tap"
                                >
                                    Send Message
                                </motion.button>
                            </motion.div>
                        </motion.div>
                    </form>
                </motion.div>
            </motion.div>
            <motion.div 
                className='endSection'
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
            >
                <motion.p
                    initial={{ y: 20 }}
                    whileInView={{ y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                >
                    © 2022 Mohit. Design by Me with 
                    <motion.span
                        whileHover={{ scale: 1.2 }}
                        transition={{ duration: 0.2 }}
                    >
                        <FavoriteIcon sx={{ color: '#01a479' }} />
                    </motion.span>
                </motion.p>
            </motion.div>
        </Container>
    )
}
const Container = styled.div`
    width:100%;
    background-color:white;
    .contact{
        width:85%;
        margin:auto;
        padding-top:20px;
        display:flex;
        flex-direction:column;
        gap:30px;
        
    }

    .middleSection{
        display:flex;
        justify-content:space-around;
    }

    .middleSection>div{
        padding:10px;
    }

    .middleSection>div>h1{
       font-size:x-large;
       margin-top:0px;
    }
    .middleSection>div p{
        margin-top:0px;
    }

    .middleSection>div a{
        text-decoration:none;
        color:#01a479;
     }

    .contactForm>form{
        display:flex;
        gap:10px;
    }
    .contactForm>form>div{
        display:flex;
        flex-direction:column;
        align-items:center;
        width:50%;
    }
    .contactForm>form>div>input{
        width:95%;
        padding:5px 5px 5px 15px;
        border:1px solid #e9ecef;
        border-radius:8px;
    }
    
    .contactForm>form>div:first-child>input{
        height:30px;
        margin-bottom:30px;
    }

    .contactForm>form>div:last-child>textarea{
        width:95%;
        height:175px;
        margin-bottom:30px;
        position:relative;
        padding:5px 5px 5px 10px;
        border:1px solid #e9ecef;
        border-radius:8px;
    }

    .contactForm>form>div:last-child>input::placeholder{
        position:absolute;
        top:15px;
    }

    .contactForm>form>div:last-child>div{
        width:95%;
        display:flex;
        align-items:center;
        justify-content:right;
    }

    .contactForm>form>div:last-child>div>button{
        background-color:#01a479;
        color:white;
        border:none;
        padding:10px 20px 10px 20px;
        border-radius:10px;
        cursor:pointer;
    }

    button:hover{
        -webkit-transform: translateY(-2px);
        transform: translateY(-2px);
        -webkit-transition: all 0.5s;
        transition: all 0.5s;
    }

    .endSection{
        display:flex;
        align-items:center;
        justify-content:center;
        height:70px;
        background-color:black;
        color:white;
        margin-top:20px;
    }
    .endSection>p{
        display:flex;
        align-items:center;
        justify-content:center;
        gap:5px;
    }

    .emailSent{
        display:flex;
        align-items:center;
        justify-content:center;
        flex-direction:column;
    }

    .emailSent>h1,.emailSent>p{
       margin-top:0px;
    }


    @media only screen and (min-width: 768px) and (max-width:1120px){
        .middleSection{
            flex-direction:column;
        }

        .contactForm>form{
            flex-direction:column;
        }

        .contactForm>form>div{
            width:70%;
        }

        .contactForm>form{
            align-items:center;
        }

        .contactForm>form>div:last-child>div{
            width:90%;
            display:flex;
            align-items:center;
            justify-content:center;
            padding-right:10px;
        }

        .contactForm>form>div:last-child>div>button{
            width:100%;
            
        }
    }
    
    @media only screen and (min-width: 481px) and (max-width:768px){
        .middleSection{
            flex-direction:column;
        }

        .contactForm>form{
            flex-direction:column;
        }

        .contactForm>form>div{
            width:80%;
        }

        .contactForm>form{
            align-items:center;
        }

        .contactForm>form>div:last-child>div{
            width:100%;
            display:flex;
            align-items:center;
            justify-content:center;
            padding-right:10px;
        }

        .contactForm>form>div:last-child>div>button{
            width:100%;
            
        }

        .emailSent>h1{
            font-size:x-large;
        }

        .emailSent>p{
            width:80%;
            font-size:small;
        }
    }

    @media only screen and (min-width:320px) and (max-width:480px){
        .middleSection{
            flex-direction:column;
        }

        .contactForm>form{
            flex-direction:column;
        }

        .contactForm>form>div{
            width:80%;
        }

        .contactForm>form{
            align-items:center;
        }

        .contactForm>form>div:last-child>div{
            width:100%;
            display:flex;
            align-items:center;
            justify-content:center;
            padding-right:10px;
        }

        .contactForm>form>div:last-child>div>button{
            width:100%;
            
        }

        .endSection>p{
            font-size:15px;
        }

        .emailSent>h1{
            font-size:large;
        }

        .emailSent>p{
            width:70%;
            font-size:12px;
        }
    }

    @media only screen and (max-width: 320px){
        .middleSection{
            flex-direction:column;
        }

        .contactForm>form{
            flex-direction:column;
        }

        .contactForm>form>div{
            width:70%;
        }

        .contactForm>form{
            align-items:center;
        }

        .contactForm>form>div:last-child>div{
            width:100%;
            display:flex;
            align-items:center;
            justify-content:center;
            padding-right:10px;
        }

        .contactForm>form>div:last-child>div>button{
            width:100%;
            
        }

        .endSection>p{
            font-size:10px;
        }

        .emailSent>h1{
            font-size:small;
        }

        .emailSent>p{
            width:70%;
            font-size:10px;
        }
    }


    @media only screen and (max-width: 319px){
        .middleSection{
            flex-direction:column;
        }

        .contactForm>form{
            flex-direction:column;
        }

        .contactForm>form>div{
            width:80%;
        }

        .contactForm>form>div:last-child>div{
            width:100%;
            display:flex;
            align-items:center;
            justify-content:center;
            padding-right:10px;
        }

        .contactForm>form>div:last-child>div>button{
            width:100%;
            
        }

        .endSection>p{

            font-size:8px;
        }
    }
    

`
export default ContactUs